import React from "react";

import { AppstoreOutlined, IdcardOutlined } from "@ant-design/icons";

import { fmt, fmtDate, phone, toFixed2 } from "#utils";

type P = Record<string, any>;

export const headerActions = [
	{ label: "Edit", type: "primary" as const },
	{ label: "Archive" },
];

export const getHeaderMeta = (plan: P) => [
	{
		icon: React.createElement(IdcardOutlined),
		label: "ID:",
		value: fmt(plan.external_id || plan.id),
	},
	{ icon: React.createElement(AppstoreOutlined), value: fmt(plan.type) },
];

export const getStatsData = (plan: P) => [
	{ label: "Discount", value: `${fmt(plan.discount_percentage, "0")}% ` },
	{ label: "Fee", value: `$${fmt(plan.fee, "0")}% ` },
	{ label: "Rebate", value: `$${toFixed2(plan.rebate)} ` },
	{ label: "Net Days", value: `${toFixed2(plan.net_amount)} ` },
];

export const getPlanDetailFields = (plan: P) => [
	{ label: "Go-Live Date", value: fmtDate(plan.golive_date) },
	{ label: "Termination Date", value: fmtDate(plan.terminated_date) },
	{ label: "Billing Type", value: fmt(plan.billing_type) },
	{ label: "Plan Type", value: fmt(plan.type) },
	{ label: "Phone", value: phone(plan.phone) },
	{ label: "Fax", value: phone(plan.fax) },
	{ label: "Website", value: fmt(plan.website), span: true },
];

export const getFinancialRows = (plan: P) => [
	{ label: "PMPM Fee", value: `$${fmt(plan.pmpm_fee, "0")}` },
	{ label: "PEPM Fee", value: `$${fmt(plan.pepm_fee, "0")}` },
	{ label: "# of Members", value: fmt(plan.employees_num, "0") },
	{ label: "# of Employees", value: fmt(plan.pe_employees_num, "0") },
	{ label: "Covered Lives", value: fmt(plan.covered_lives, "0") },
	{ label: "Sales Rep", value: fmt(plan.salesRep) },
];

export const getAccountManagerRows = (plan: P) => [
	{ label: "Phone", value: phone(plan.vendor_phone) },
	{ label: "Fax", value: phone(plan.vendor_fax) },
];

export const getOverrideRows = (plan: P) => [
	{
		label: "Drug Level Override",
		value: fmt(plan.plan_override, "No"),
	},
	{
		label: "Override Pricing",
		value: fmt(plan.override, "No"),
	},
];

export const carrierColumns = [
	{
		title: "Carrier Name",
		dataIndex: "carrier_id",
		key: "carrier_name",
		render: (carrierID: P | undefined) => fmt(carrierID?.name),
	},
	{
		title: "Effective Date",
		dataIndex: "golive",
		key: "golive",
		render: fmtDate,
	},
];

export const pbmColumns = [
	{ title: "PBM Name", dataIndex: "pbm", key: "pbm" },
	{
		title: "Effective From",
		dataIndex: "from_date",
		key: "from_date",
	},
	{
		title: "Effective To",
		dataIndex: "to_date",
		key: "to_date",
	},
];

export const getContactRows = (plan: P) => {
	const contacts = Array.isArray(plan.contact) ? plan.contact : [];
	return contacts
		.filter((c: Record<string, any>) => c.show_to_snap === "Yes")
		.map((c: Record<string, any>) => ({
			name: fmt(c.name),
			type: fmt(c.type),
			phone: fmt(c.work),
			email: fmt(c.email),
		}));
};
